import { ReactElement } from 'react';

import { InteractiveTable } from '@dreryk/react-components';

import { DiagnosesController, DiagnosesFromBeanPart, DiagnosisTableBean } from '../DiagnosesFormTab.types';

import {
   useDiagnosesInteractiveTableColumnsConfiguration,
   useDiagnosesInteractiveTableValidation,
} from './DiagnosesInteractiveTable.hooks';

type DiagnosesInteractiveTableProps = Pick<DiagnosesController, 'register'> & {
   readonly header: ReactElement;
   readonly placeholder: ReactElement;
   readonly required: boolean;
   readonly chronicEditable: boolean;
   readonly visitId: number;
};

export const DiagnosesInteractiveTable = (props: DiagnosesInteractiveTableProps): JSX.Element => {
   return (
      <InteractiveTable<DiagnosisTableBean, DiagnosesFromBeanPart>
         testId={'diagnoses'}
         name={'diagnoses.value'}
         register={props.register}
         validation={useDiagnosesInteractiveTableValidation(props.required)}
         columns={useDiagnosesInteractiveTableColumnsConfiguration(props.chronicEditable, props.visitId)}
         header={props.header}
         placeholder={props.placeholder}
         autoScroll={'start'}
      />
   );
};
